import { render } from "./ElevatorsControl.vue?vue&type=template&id=8687ed46"
import script from "./ElevatorsControl.vue?vue&type=script&lang=js"
export * from "./ElevatorsControl.vue?vue&type=script&lang=js"

import "./ElevatorsControl.vue?vue&type=style&index=0&id=8687ed46&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__